import React, { useEffect, useState } from "react";
import PickingListDetailtable, {
  ProductImageCell,
  StatusPill,
  ModalCell,
} from "./PickingListDetailtable";
function PickingListDetaildata() {
  let [products, setProducts] = useState({
    count: 4,
  });
  var counter = 5;
  var pick = 0;
  console.log("outside count", products.count);
  const handleChange = (e) => {
    console.log("inside handel chnage count", products.count);
    if (e.target.value > 0) {
      setProducts({ count: e.target.value || 0 });
    } else {
      console.log("out of stock");
    }
  };

  const decrease = (e) => {
    if (products.count <= 0) {
      return;
    }
    console.log("count in decrease", products.count);
    console.log("e.target.value", e.target.value);

    if (e.target.value > 0) {
      counter = counter - parseInt(e.target.value);
      pick = counter + parseInt(e.target.value);

      if (counter == 0 || counter < 0) {
        alert("out of stock");
        counter = 0;
      }
      setProducts({ count: products.count - e.target.value });
      console.log("inside if", products.count);
    } else {
      console.log("out of stock");
    }
    console.log("count", products.count);
  };

  const data = [
    {
      id: "1",
      number: "10254354545",
      itemname: "Dutch Grown",
      status: "Active",
      version: "1.2",
      stock: "1",
    },
    {
      id: "2",
      number: "10254354545",
      itemname: "Cambo",
      status: "Discontinued",
      version: "1.2",
      stock: "1",
    },
    {
      id: "3",
      number: "10254354545",
      itemname: "Avon Bulbs",
      status: "Active",
      version: "1.2",
      stock: "2",
    },
    {
      id: "4",
      number: "10254354545",
      itemname: "Broardleight Bulbs",
      status: "Active",
      version: "1.2",
      stock: "4",
    },
    {
      id: "5",
      number: "10254354545",
      itemname: "Dutch Grown",
      status: "Active",
      version: "1.2",
      stock: "10",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },

      {
        Header: "Number",
        accessor: "number",
      },
      {
        Header: "Item Name",
        accessor: "itemname",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: StatusPill,
      },

      {
        Header: "Image",
        accessor: "img",
        Cell: ProductImageCell,
      },

      {
        Header: "QTY in Stock",
        accessor: "stock",
        Cell: (value) => (
          <div class=" flex w-1/2 mr-8 ">
            <input
              class="w-full bg-transparent p-2"
              type="text"
              // value={products.count}
              value={counter}
              onChange={(e) => {
                decrease(e);
                handleChange(e);
              }}
              // onChange={handleChange}
            />
          </div>
        ),
      },
      {
        Header: "Pick QTY",
        accessor: "pick",
        Cell: (value) => (
          <div class=" flex w-1/2 mr-8 ">
            <input
              class="w-full bg-transparent p-2"
              type="text"
              // value={products.count}
              value={pick}
              onChange={(e) => {
                decrease(e);
                handleChange(e);
              }}
              // onChange={handleChange}
            />
          </div>
        ),
      },
      {
        Header: "Picked QTY",
        accessor: "picked",
        Cell: (value) => (
          <div class=" flex border  w-3/4 mr-8  rounded-lg">
            <input
              class="w-full rounded-lg p-2"
              type="text"
              onChange={decrease}
            />
          </div>
        ),
      },
      {
        Header: "Scan Picking Barcode",
        accessor: "scan",
        Cell: ModalCell,
      },
      {
        Header: "Report",
        accessor: "report",
        Cell: (value) => (
          <div className="flex flex-wrap">
            <div className="mt-5">
              <svg
                width="30"
                height="26"
                viewBox="0 0 30 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.1465 0L27.9661 19.5H2.32695L15.1465 0Z"
                  fill="#1F78B4"
                />
                <path
                  d="M16.2471 7.35L16.0071 14.595H14.2371L13.9821 7.35H16.2471ZM15.1671 18.105C14.7871 18.105 14.4721 17.99 14.2221 17.76C13.9821 17.52 13.8621 17.225 13.8621 16.875C13.8621 16.525 13.9821 16.235 14.2221 16.005C14.4721 15.765 14.7871 15.645 15.1671 15.645C15.5371 15.645 15.8421 15.765 16.0821 16.005C16.3221 16.235 16.4421 16.525 16.4421 16.875C16.4421 17.225 16.3221 17.52 16.0821 17.76C15.8421 17.99 15.5371 18.105 15.1671 18.105Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <PickingListDetailtable
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default PickingListDetaildata;
